import { PRESUPUESTADOR_DELETE_PAYMENT_METHOD } from './constants'

export function deletePaymentMethod(paymentMethodIndex) {
  return {
    type: PRESUPUESTADOR_DELETE_PAYMENT_METHOD,
    data: {
        paymentMethodIndex,
    },
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_DELETE_PAYMENT_METHOD) {
    const newPaymentsMethods = state.payments_methods.filter((_, index) => action.data.paymentMethodIndex !== index)

    return {
      ...state,
      payments_methods: newPaymentsMethods,
    }
  } else {
    return state
  }
}
